import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum, AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import "./insPortfolioCreationManualCompositionTab.scss";
import { ModalName } from "../../types";
import { InsPortfolioCreationManualCompositionGrid, portfolioCreationManualCompositionGridId } from "./insPortfolioCreationManualCompositionGrid";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { removeAllEditedRow, removeAllSelectedRow } from "store/grids";
import { openModal } from "store/modal";
import { AddInvestorAccountsOrFundsMode } from "store/modal/portfolio-creation-types";
import { getCurrentLocalTime } from "common/date-utils";
export const InsPortfolioCreationManualCompositionTab = () => {
    const dispatch = useDispatch(), selectedRowsLengthZero = useSelector((state) => state.grids.state[portfolioCreationManualCompositionGridId]?.selectedRows?.length) === 0;
    const handleRemoveAllButton = () => {
        batch(() => {
            dispatch(removeAllSelectedRow(portfolioCreationManualCompositionGridId));
            dispatch(removeAllEditedRow(portfolioCreationManualCompositionGridId));
        });
    };
    return React.createElement("div", { className: "insPortfolioCreationManualCompositionTab" },
        React.createElement("div", { className: "insPortfolioCreationManualCompositionTab__header" },
            React.createElement("div", { className: "insPortfolioCreationManualCompositionTab__header_flexbox" },
                React.createElement(AuxButton, { label: language.en.modal.portfolioCreation.portfolioCreationManualComposition.addFunds, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.SECONDARY, onClick: () => {
                        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.CreatePortfolioAddFunds, properties: { LocalTimestamp: getCurrentLocalTime() } });
                        dispatch(openModal({
                            content: {
                                id: "add-investor-accounts",
                                modalName: ModalName.AddInvestorAccountsOrFunds,
                                parameters: {
                                    mode: AddInvestorAccountsOrFundsMode.AddFunds
                                }
                            },
                            title: language.en.modal.portfolioCreation.portfolioCreationManualComposition.addFunds,
                            type: "action"
                        }));
                    } }),
                React.createElement(AuxButton, { label: language.en.modal.portfolioCreation.portfolioCreationManualComposition.addInvestorAccountAction, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.SECONDARY, onClick: () => {
                        appInsightsTrackEvent({
                            name: appInsightEvents.customEvents.names.CreatePortfolioAddInvestorAccounts,
                            properties: { LocalTimestamp: getCurrentLocalTime() }
                        });
                        dispatch(openModal({
                            content: {
                                id: "add-investor-accounts",
                                modalName: ModalName.AddInvestorAccountsOrFunds,
                                parameters: {
                                    mode: AddInvestorAccountsOrFundsMode.AddInvestorAccounts
                                }
                            },
                            title: language.en.modal.portfolioCreation.portfolioCreationManualComposition.addInvestorAccountAction,
                            type: "action"
                        }));
                    } }),
                React.createElement(AuxButton, { label: language.en.modal.portfolioCreation.portfolioCreationManualComposition.removeAll, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.SECONDARY, className: "insPortfolioCreationManualCompositionTab__header__rightButton", isDisabled: selectedRowsLengthZero, onClick: handleRemoveAllButton }))),
        React.createElement("div", { className: "insPortfolioCreationManualCompositionTab__content" },
            React.createElement(InsPortfolioCreationManualCompositionGrid, null)));
};
